import { Box } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { EFButton, EFTypography } from '~/components'
import { ALL_NS } from '~/i18n/namespaces'

export enum NotAuthorizedReasonType {
  NotAuthorized = 'NotAuthorized',
  NoDataPermission = 'NoDataPermission',
}

export default function NotAuthorized() {
  const { t } = useTranslation(ALL_NS)
  const navigate = useNavigate()
  const location = useLocation();

  const status = location.state?.status as NotAuthorizedReasonType | undefined;

  const getMessageDescription = () => {
    switch (status) {
      case NotAuthorizedReasonType.NoDataPermission:
        return t('Message_DoNotHaveAllFleetsDataPermissionToAccessPage')
      case NotAuthorizedReasonType.NotAuthorized:
      default:
        return t('Message_DoNotHaveAccessToPage')
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '50vh'
      }}
    >
      <EFTypography
        variant='h1'
        fontWeight='600'
        fontSize='4rem !important'
        color='warning'
      >
        {t('PageTitle_AccessDenied')}
      </EFTypography>
      <EFTypography
        variant='h6'
        fontSize='1.3rem !important'
        textAlign='center'
        color='warning'
      >
        {getMessageDescription()}
      </EFTypography>
      <EFButton
        onClick={() => navigate('/')}
        sx={{ height: '3rem !important', marginTop: '1rem' }}
        variant='contained'
      >
        {t('Button_BackHome')}
      </EFButton>
    </Box>
  )
}
